import type { ReactNode } from 'react'
import { Lock } from 'lucide-react'
import ProAnfrageKnopf from './ProAnfrageKnopf'

/**
 * Inhalt hinter der Bezahlschranke: unscharfe Attrappe, darueber der Hinweis
 * auf Pro. Wie beim LoginGate stehen dahinter keine echten Daten -- das
 * Backend kuerzt kostenlose Konten selbst (tarife.py).
 */
export default function ProGate({ titel, vorschau }: { titel: string; vorschau: ReactNode }) {
  return (
    <div className="q-gate">
      <div className="q-gate-teaser" aria-hidden="true">
        {vorschau}
      </div>
      <div className="q-gate-overlay">
        <Lock aria-hidden="true" />
        <span className="q-gate-title">{titel}</span>
        <ProAnfrageKnopf />
      </div>
    </div>
  )
}
